import { SizeChartModal } from "@faire/deprecated-retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/SizeChartModal";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { trackEvent } from "@faire/web/common/trackEvent";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useState } from "react";

interface IProps {
  brand: IProductPageResponse.IPdpBrand;
  product: IProductPageResponse.IPdpProduct;
}

export const SizeChartLink: React.FC<IProps> = ({ brand, product }) => {
  const [showSizeChartModal, setShowSizeChartModal] = useState<boolean>(false);

  const onOpen = () => {
    setShowSizeChartModal(true);
    trackEvent(`/size-chart-modal/${brand.token}/${product.token}`);
  };

  if (!brand.brand_size_chart?.url) {
    return null;
  }

  return (
    <>
      <Typography align="right">
        <Button
          variant="tertiary"
          onClick={onOpen}
          style={{ whiteSpace: "nowrap" }}
          data-test-id="product-size-chart-link"
        >
          <StrictLocalMsg
            id="7YVqAM"
            defaultMessage="Size Chart"
            description={{ text: "View the size chart defined by the brand" }}
          />
        </Button>
      </Typography>
      {showSizeChartModal ? (
        <SizeChartModal
          brand={brand}
          product={product}
          onClose={() => setShowSizeChartModal(false)}
        />
      ) : null}
    </>
  );
};
